var map = {
	"./address.js": "UUNZ",
	"./aggPack.js": "ycDY",
	"./im.js": "TLUi",
	"./user.js": "bREw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "w+hY";


//////////////////
// WEBPACK FOOTER
// ./src/store/modules \.js$
// module id = w+hY
// module chunks = 115